import "../../styles/bootstrap/bootstrap-popover.scss";
import "../../styles/popoverOverride.scss";
import "./formIdentifierList.scss";
import "./formList.scss";

import _ from "lodash";
// import ImmutablePropTypes from "react-immutable-proptypes";
import PropTypes from "prop-types";
import React, { createRef, Fragment } from "react";
import { PopoverBody } from "reactstrap";

import NavigationToolbar from "../../components/navigationToolbar";
import { withScreenContext } from "../../components/screen/ScreenContext";
import KeyConstants from "../../constants/keyConstants";
import { isScreenModeMobile } from "../../constants/screenModes";
import { PropTypeShapes } from "../../types";
import preprocessorQuery from "../../utils/preprocessorQuery";
import uniqueId from "../../utils/uniqueId";
import { withContainerContext } from "../container/ContainerContext";
import Icon from "../interface/Icon";
import Identifier from "../interface/Identifier";
import { withModalSizeContext } from "../modal/ModalSizeContext";
import { popoverOrPortal } from "../portal/popoverOrPortal";
import FormSearchField from "./FormSearchField";
import { getDropdownOptions, getFilteredOptions } from "./utils";

const SAFE_SPACE = "__SPACE__";
const SAFE_NULL = "__NULL__";

const isIos = preprocessorQuery.isIos();
const isTablet = preprocessorQuery.isTablet();
const isMobile = preprocessorQuery.isMobile();

class FormIdentifierList extends React.Component {
  constructor(props) {
    super(props);
    this.state = { showMenu: false, options: null, searchText: "", highlightValue: null };
    this._domNode = null;
    this.getSelectedOption = this.getSelectedOption.bind(this);
    this.showMenu = this.showMenu.bind(this);
    this.hideMenu = this.hideMenu.bind(this);
    this.searchChanged = this.searchChanged.bind(this);
    this.onDownArrow = this.onDownArrow.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.toggle = this.toggle.bind(this);
    this._dropdownId = "x" + uniqueId();
    this._searchRef = createRef();
  }

  componentWillReceiveProps(nextProps) {
    const options = this.state.showMenu ? getDropdownOptions(nextProps.options) : null;
    this.setState({ searchText: "", options });
  }

  getSelectedOption(props) {
    const options = getDropdownOptions(props.options);
    return options.find(val => val.value === props.value);
  }

  toggle() {
    if (this.state.showMenu) {
      this.hideMenu();
    } else {
      this.showMenu();
    }
  }

  getListItemDomId(opt) {
    const val = opt.value ? opt.value.replace(/\s/g, SAFE_SPACE) : SAFE_NULL;
    return `${this._dropdownId}-${val}`;
  }

  onDownArrow() {
    this._listViewDom ? this._listViewDom.focus() : null;
    this.moveHighlight(1);
  }

  onKeyDown(e) {
    // Is it already open...?

    let keyHandled = false;

    if (this.state.showMenu) {
      switch (e.key) {
        case KeyConstants.Escape:
          this.hideMenu();
          keyHandled = true;
          break;
        case KeyConstants.Tab: {
          if (this.state.highlightValue) {
            this.selectHighlightedOption(true);
            this.hideMenu();
          } else {
            this.hideMenu();
          }
          // TODO: was not calling stopPropagation on this... should we?
          // keyHandled = true;
          break;
        }
        case KeyConstants.Enter: {
          if (this.state.highlightValue) {
            this.selectHighlightedOption(false);
          } else {
            this.hideMenu();
          }
          keyHandled = true;
          this.focus();
          break;
        }
        case KeyConstants.Up:
          this.moveHighlight(-1);
          keyHandled = true;
          break;
        case KeyConstants.Down:
          this.moveHighlight(1);
          keyHandled = true;
          break;
        case KeyConstants.Left:
        case KeyConstants.Right:
          keyHandled = true;
          break;
        default:
          this._searchRef && this._searchRef.current ? this._searchRef.current.focus() : null;
          break;
      }
    } else {
      // Not currently open.
      // So open it with "enter"
      switch (e.key) {
        case KeyConstants.Enter:
          this.showMenu();
          keyHandled = true;
          break;
        default:
          break;
      }
    }

    if (keyHandled) {
      e.stopPropagation();
      e.preventDefault();
    }
  }

  onKeyPress(_e) {
    // TODO: When the user types a key, we should jump directly to that character...?
  }

  onBlur(_e) {}

  selectHighlightedOption(selectOnly) {
    if (this.state.showMenu && this.state.highlightValue) {
      this.optionClick(this.state.highlightValue, selectOnly);
    }
  }

  moveHighlight(delta) {
    const filteredOptions = getFilteredOptions(this.state.options, this.state.searchText);
    // If there are no options, do nothing
    if (filteredOptions.length === 0) {
      return;
    }
    let highlightIndex = _.findIndex(filteredOptions, opt => opt.value === this.state.highlightValue);
    if (_.isNil(highlightIndex)) {
      highlightIndex = -1;
    }

    highlightIndex += delta;
    if (highlightIndex < 0) {
      highlightIndex = 0;
    }
    if (highlightIndex >= filteredOptions.length) {
      highlightIndex = filteredOptions.length - 1;
    }
    let highlightValue = filteredOptions[highlightIndex].value;
    this.setState({ highlightValue });
    this.scrollToElement(filteredOptions[highlightIndex]);
  }

  showMenu() {
    const options = getDropdownOptions(this.props.options);
    this.setState({ showMenu: true, highlightValue: null, options });
    if (this.props.onToggleMenu) {
      this.props.onToggleMenu(true);
    }
  }

  hideMenu() {
    this.setState({ showMenu: false, searchText: "", options: null });
    if (this.props.onToggleMenu) {
      this.props.onToggleMenu(false);
    }
  }

  scrollToElement(val) {
    let domId = null;
    const options = getFilteredOptions(this.state.options, this.state.searchText);
    if (val && val.value && options.findIndex(o => o.value === val.value) >= 0) {
      domId = this.getListItemDomId(val);
    }
    const domNode = document.getElementById(domId);
    if (domNode) {
      domNode.scrollIntoViewIfNeeded ? domNode.scrollIntoViewIfNeeded() : domNode.scrollIntoView();
    }
  }

  optionClick(value, selectOnly = false) {
    const wasSelected = Boolean(this.props.values.find(v => v.id === value));
    if (selectOnly && wasSelected) {
      return;
    }
    this.props.onChange(value, !wasSelected);
  }

  searchChanged(searchText) {
    const filteredOptions = getFilteredOptions(this.state.options, searchText);
    const highlightIndex = _.findIndex(filteredOptions, opt => opt.value === this.state.highlightValue);
    if (highlightIndex < 0) {
      this.setState({ searchText, highlightValue: null });
    }
    this.setState({ searchText });
  }

  focus() {
    this._domNode.focus();
    // if (this.props.openOnFocus) {
    // this.showMenu();
    // }
  }

  renderOptionIcon(opt) {
    if (opt.icon) {
      return <Icon icon={opt.icon} color={opt.color} />;
    } else if (opt.color) {
      return <div className={`dropdownColor ${opt.color}`} />;
    } else {
      return null;
    }
  }

  renderMenuOptions() {
    const filteredOptions = getFilteredOptions(this.state.options, this.state.searchText);

    let style = {};
    //#!if mobile === true
// style.paddingLeft = Math.max(this.props.paddingLeft, 5);
// style.paddingRight = Math.max(this.props.paddingRight, 5);
    //#!endif

    return filteredOptions.map(opt => {
      const selected = Boolean(this.props.values && this.props.values.find(v => v.id === opt.value));
      const optClass = `dropdownMenuOption ${selected ? "selected" : ""} ${
        opt.value === this.state.highlightValue ? "highlighted" : ""
      }`;
      return (
        <div
          className={optClass}
          style={style}
          key={opt.value}
          id={this.getListItemDomId(opt)}
          onClick={() => this.optionClick(opt.value)}
        >
          <div className="dropdownTick">
            <svg className="icon mono">
              <use xlinkHref={selected ? "#tick" : "#blank"} />
            </svg>
          </div>
          {this.renderOptionIcon(opt)}
          <div className="dropdownText">
            <div className="dropdownLabel">{opt.label}</div>
          </div>
        </div>
      );
    });
  }

  renderMenuSearch() {
    if (this.props.allowSearch) {
      return (
        <FormSearchField
          //#!if iOS !== true
          autoFocus={true}
          //#!endif
          ref={this._searchRef}
          placeholder="Filter"
          value={this.state.searchText}
          onChange={this.searchChanged}
          onDownArrow={this.onDownArrow}
          continuouslyUpdates={true}
          showSearchIcon={true}
          showClearIcon={true}
        />
      );
    }
    return null;
  }

  renderMenu() {
    if (this.state.showMenu && !this.props.disabled) {
      // Merge the modal heights
      let style = Object.assign({}, this.props.style || {});
      if (this.props.alwaysPortal) {
        style.maxHeight = this.props.maxHeight;
        style.height = this.props.fixedHeight;
      }

      style.width =
        this.props.useParentWidth &&
        this._domNode &&
        this._domNode.clientWidth &&
        (!this.props.screenContext || !isScreenModeMobile(this.props.screenContext.screenMode))
          ? `${this._domNode.clientWidth}px`
          : this.props.style && this.props.style.width
            ? this.props.style.width
            : `auto`;

      return (
        <div
          style={style}
          className={`dropdownMenu ${this.props.allowSearch ? "" : "noSearch"}`}
          tabIndex={0}
          ref={domNode => (this._listViewDom = domNode)}
        >
          {this.renderMenuSearch()}
          <div className="dropdownMenuOptions">{this.renderMenuOptions()}</div>
        </div>
      );
    }
    return null;
  }

  renderVisibleList() {
    let children = null;
    if (this.props.values) {
      children = this.props.values.skipLast(this.props.remaining).map((v, index) => {
        const color = v.isAvatar ? v.color : "iconFade";
        return (
          <Identifier
            key={index}
            {...v.toJS()}
            color={color}
            size={this.props.isTableCell ? v.tableCellSize : v.size}
          />
        );
      });
    }
    return children;
  }

  renderPopover() {
    let placement = "bottom-start";
    let hideArrow = true;
    let alwaysPortal = false;
    if (isTablet) {
      placement = "bottom-end";
      hideArrow = false;
    }

    let popoverOptions = {
      className: `dropdownPopover${isIos ? " iosModalContentWrap" : ""} ${
        this.props.popoverClassName ? this.props.popoverClassName : ""
      }`,
      placement,
      hideArrow,
      isOpen: this.state.showMenu,
      target: this._dropdownId,
      toggle: this.hideMenu
    };

    const child = (
      <Fragment>
        {this.props.screenContext && isScreenModeMobile(this.props.screenContext.screenMode) ? (
          <NavigationToolbar
            title={this.props.title}
            showBack={true}
            showBackArrow={true}
            onBackClick={this.toggle}
            backText={this.props.backText ? this.props.backText : "Back"}
            flexLeft={1}
            flexCenter={3}
            flexRight={1}
          />
        ) : null}
        <PopoverBody onClick={e => e.stopPropagation()}>{this.renderMenu()}</PopoverBody>
      </Fragment>
    );

    return popoverOrPortal(child, popoverOptions, alwaysPortal, this.props.disableTabLock);
  }

  getRemainingIndicator() {
    const { remaining } = this.props;
    return remaining ? <div className="formIdentifierListRemaining">{`+${remaining}`}</div> : null;
  }

  render() {
    const arrowIcon = isMobile ? "rightArrow" : "downArrow";

    return (
      <div
        className="formIdentifierListWrapper"
        ref={node => (this._domNode = node)}
        tabIndex={this.props.disabled ? -1 : 0}
        onBlur={this.onBlur}
        onKeyDown={this.onKeyDown}
        id={this._dropdownId}
      >
        <div
          className={`formIdentifierList ${this.props.disabled ? "disabled" : ""}`}
          onClick={this.props.disabled ? null : this.toggle}
        >
          <div className="identifiers">{this.renderVisibleList()}</div>
          <div className="formIdentifierArrowWrapper">
            <Icon className="downArrow" icon={arrowIcon} color="mono" />
            {this.getRemainingIndicator()}
          </div>
        </div>
        {this.state.showMenu ? this.renderPopover() : null}
      </div>
    );
  }
}

FormIdentifierList.propTypes = {
  options: PropTypes.oneOfType([PropTypeShapes.listOptionArray, PropTypes.func]).isRequired,
  values: PropTypeShapes.identifierList,
  remaining: PropTypes.number,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  allowSearch: PropTypes.bool,
  closeOnClick: PropTypes.bool,
  popoverClassName: PropTypes.string,
  onToggleMenu: PropTypes.func,
  title: PropTypes.string,
  backText: PropTypes.string,
  useParentWidth: PropTypes.bool.isRequired,
  style: PropTypes.object,
  disableTabLock: PropTypes.bool,
  isTableCell: PropTypes.bool,

  //#!if iOS === true
// alwaysPortal: PropTypes.bool,
// 
  // From withScreenContext
// screenContext: PropTypes.object,
// 
  // From ModalSizeContext
// maxHeight: PropTypes.number,
// fixedHeight: PropTypes.number,
// 
  // From withContainerContext
// paddingLeft: PropTypes.number,
// paddingRight: PropTypes.number
  //#!endif

  //#!endif
};

FormIdentifierList.defaultProps = {
  useParentWidth: true
};

let exportedView = FormIdentifierList;
//#!if iOS === true
// exportedView = withContainerContext(withScreenContext(withModalSizeContext(FormIdentifierList)));
//#!endif
export default exportedView;
